// extracted by mini-css-extract-plugin
module.exports = {"root":"BaseSlider_root__2oYut","rail":"BaseSlider_rail__ufx1O","track":"BaseSlider_track__2f2-E","thumb":"BaseSlider_thumb__2LiSg"};